import { render, staticRenderFns } from "./TicketPadrao.vue?vue&type=template&id=2b56a0e8&scoped=true&lang=pug"
import script from "./TicketPadrao.vue?vue&type=script&lang=js"
export * from "./TicketPadrao.vue?vue&type=script&lang=js"
import style0 from "./TicketPadrao.vue?vue&type=style&index=0&id=2b56a0e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56a0e8",
  null
  
)

export default component.exports